import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';
import { PRICE_CHECKER_CREATIVE_ID } from 'site-modules/shared/constants/price-checker';

const map = {
  pc_mode_select: TrackingEvent.actionCompleted(TrackingConstant.ACTION_TOOL_SELECT, TrackingConstant.TAB_SELECT),
  pc_make_select: TrackingEvent.actionStart(TrackingConstant.ACTION_MMY_SELECT, TrackingConstant.MAKE_SELECT),
  pc_model_select: TrackingEvent.actionProgress(TrackingConstant.ACTION_MMY_SELECT, TrackingConstant.MODEL_SELECT),
  pc_year_select: TrackingEvent.actionProgress(TrackingConstant.ACTION_MMY_SELECT, TrackingConstant.YEAR_SELECT),
  pc_style_select: TrackingEvent.actionProgress(TrackingConstant.ACTION_MMY_SELECT, TrackingConstant.STYLE_SELECT),
  pc_vin_error_style_select: TrackingEvent.actionProgress(TrackingConstant.ACTION_MMY_SELECT, 'vin_error_style_select'),
  pc_msrp_input: TrackingEvent.actionProgress(TrackingConstant.ACTION_TOOL_SELECT, 'user_msrp'),
  pc_dealer_price_input: TrackingEvent.actionProgress(TrackingConstant.ACTION_TOOL_SELECT, 'user_dealer_offer_price'),
  pc_msrp_input_error: TrackingEvent.actionProgress(TrackingConstant.ACTION_TOOL_SELECT, 'msrp_error'),
  pc_dealer_price_error: TrackingEvent.actionProgress(TrackingConstant.ACTION_TOOL_SELECT, 'dealer_price_quote_error'),
  pc_submit_prices: TrackingEvent.actionEnd(TrackingConstant.ACTION_SHOW_CONTENT, 'price_checker_submit'),
  pc_show_result: TrackingEvent.actionCompleted(TrackingConstant.ACTION_SHOW_CONTENT, 'price_checker_rating'),
  pc_show_compare_offers: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_SHOW_CONTENT,
    'price_checker_drawer_button'
  ),
  pc_can_decode_vin: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.SQUISHVIN_ENDPOINT
  ),
  pc_cant_decode_vin: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.SUBACTION_VIN_ERROR
  ),
  pc_vin_error_not_found: TrackingEvent.actionCompleted(TrackingConstant.ACTION_TOOL_SELECT, 'vin_error_not_found', {
    action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
    action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
    creative_id: PRICE_CHECKER_CREATIVE_ID,
  }),
  pc_view_features_specs: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_FEATURES_SPECS
  ),
  pc_why_no_rate_answer: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    'price_checker_intercept_answer'
  ),
  pc_why_no_rate_comment: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    'price_checker_intercept_comment'
  ),
  pc_taxes_fees_collapse: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.HIDE_OUT_THE_DOOR_PRICE_DETAILS
  ),
  pc_taxes_fees_expand: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.SHOW_OUT_THE_DOOR_PRICE_DETAILS
  ),
  pc_go_to_appraiser: TrackingEvent.actionCompleted(TrackingConstant.ACTION_TOOL_SELECT, 'go_to_appraiser'),
  pc_calculators_collapse: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.HIDE_CALCULATORS
  ),
  pc_calculators_expand: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.SHOW_CALCULATORS
  ),
  pc_buy_sell: TrackingEvent.actionCompleted(TrackingConstant.ACTION_TOOL_SELECT, 'price_checker_buy_sell'),
  pc_vin_in_text: TrackingEvent.actionCompleted(TrackingConstant.ACTION_TOOL_SELECT, 'vin_link_in_text'),
  pc_link_to_calculator: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.LINK_TO_CALCULATOR
  ),
  pc_shopper_forums: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.SHOPPER_FORUMS
  ),
  share_deal: TrackingEvent.actionCompleted(TrackingConstant.ACTION_SHARE_CONTENT, TrackingConstant.SHARE_DEAL),
  pc_completed_survey: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_ENGAGE_SURVEY,
    'completed_price_checker_survey'
  ),
  pc_survey_dissat_comments: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_ENGAGE_SURVEY,
    'price_checker_survey_dissat_comments'
  ),
  pc_survey_neutral_comments: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_ENGAGE_SURVEY,
    'price_checker_survey_neutral_comments'
  ),
  pc_survey_sat_comments: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_ENGAGE_SURVEY,
    'price_checker_survey_sat_comments'
  ),
  // TODO: Review after msrp social
  view_pricing_bar_details: TrackingEvent.actionCompleted(
    TrackingConstant.VIEW_PRICING_DETAILS,
    'view_pricing_bar_details'
  ),
};

export const PriceCheckerMap = {
  ...map,
};
